import Navbar from "../Components/NavbarItems/Navbar";
import Footer from "../Components/FooterItems/Footer";
import MembershipFormDetails from "../Components/Membership/MembershipFormDetails";

function MembershipForm() {
  return (
    <>
      <Navbar />
      <MembershipFormDetails />
      <Footer />
    </>
  );
}

export default MembershipForm;
